function openSizeGuide() {
  document.getElementById('sizeGuideModal').style.display = 'block';
  document.body.style.overflow = 'hidden';
}

function closeSizeGuide() {
  document.getElementById('sizeGuideModal').style.display = 'none';
  document.body.style.overflow = 'auto';
}

// Close modal when clicking outside
window.onclick = function(event) {
  const modal = document.getElementById('sizeGuideModal');
  if (event.target == modal) {
    closeSizeGuide();
  }
}

// Close modal with ESC key
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeSizeGuide();
  }
});